import { LKDate } from 'loankeeper-common/helpers/Date'

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_loan_assistant',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    StartDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    EndDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },
  },
}

export default config
